import type { Contract, FormSchema } from '../types'
import { SectionForm } from './SectionForm'
import { visibilityMode } from './SectionVisibilityBadge'

type Props = {
  contract: Contract
  schema: FormSchema
}

/**
 * Sekcje o renderTarget === 'SIDEBAR' renderowane w prawej kolumnie umowy,
 * pod blokiem "Etap aktualny" (TaskSidebar). Zawsze widoczne.
 * Jeśli brak sekcji SIDEBAR (lub wszystkie ukryte) -- zwraca null.
 */
export function ContractSidebarSections({ contract, schema }: Props) {
  const sidebarSections = schema.sections.filter(
    s => s.renderTarget === 'SIDEBAR' && visibilityMode(contract.sectionVisibility[s.code]) !== 'HIDDEN',
  )

  if (sidebarSections.length === 0) return null

  return (
    <aside className="flex flex-col gap-4 py-2">
      {sidebarSections.map(section => (
        <div key={section.code}>
          <div className="px-4 mb-1">
            <h3 className="text-[10px] uppercase tracking-wide font-semibold text-slate-500">
              {section.labelPl}
            </h3>
          </div>
          <SectionForm
            contract={contract}
            schema={schema}
            sectionCode={section.code}
            visibility={contract.sectionVisibility[section.code]}
            variant="sidebar"
          />
        </div>
      ))}
    </aside>
  )
}
